import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom"
import { connect } from 'react-redux'
import { fetchSearchInput, setInterval, fetchProducts } from '../actions'

class Footer extends Component {

    goToHomepage() {
        this.props.fetchSearchInput('')
        this.props.fetchProducts('')
        this.props.history.push('/')
    }

    goToCategories() {
        this.props.fetchSearchInput('categories')
        this.props.fetchProducts('categories')
        this.props.history.push('/search/categories')
    }

    render() {
        return (
            <div id="foot">
                <div className="bg-white">
                    <div className="container">
                        {/* B2B ICON */}
                        {/* <a className="btn custom-b2b-btn" style={{ position:'fixed',bottom: 20, left: 20 }} onClick={() => { this.props.history.push('/contactus') }}>สำหรับลูกค้าธุรกิจ คลิกที่นี่!</a> */}
                        <div className='hidden-xs'>
                            <div className="row">
                                <div className="col-md-6 col-sm-6 responsive-utilities-test">
                                    <h3>บริการส่งของสดจากตลาด</h3>
                                    <div className="text-thin">
                                        ส่งสดดอทคอม บริการส่งของสดจากตลาดถึงมือคุณ เพื่อให้คุณสะดวกสบายในการชอปปิ้งของสด ง่ายๆเพียงปลายนิ้ว
                                    </div>
                                    <br /><br />
                                    <div className="text-thin">
                                        Songsod.com © 2017 - 2022. All Rights Reserved.<br /> Powered by Lobstertech Co., Ltd. <br />
                                        <a href="https://www.freepik.com/free-photo/uncooked-marine-products-and-seasonings-at-kitchen_1474812.htm">Designed by Freepik</a>
                                    </div>
                                    <br />
                                </div>
                                <div className="col-md-6 col-sm-6 responsive-utilities-test">
                                    <div>
                                        <h3>ติดต่อเรา</h3>
                                        <div className="glyphicon glyphicon-map-marker"></div> บริษัท ยิ่งเจริญ เฟรชเมท จำกัด <br /> 651 ถนนพหลโยธิน แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร<br />
                                    </div>
                                    <div className="glyphicon glyphicon-envelope"></div> marketing@freshmate.co<br />
                                    FB: <a href="https://www.facebook.com/songsoddelivery">facebook.com/songsoddelivery</a><br />
                                    Line@ <a href="https://line.me/R/ti/p/%40songsod">@songsod</a><br />
                                </div>
                            </div>
                        </div>
                        <div className='hidden-sm hidden-md hidden-lg'>
                            <h5 style={{ textAlign: 'center', paddingTop: 20 }}>Songsod.com © 2017 - 2022. All Rights Reserved.<br /> Powered by Lobstertech Co., Ltd.</h5>
                        </div>
                    </div>
                    <br />
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return { searchinput: state.searchinput };
}

export default connect(null, { fetchSearchInput, setInterval, fetchProducts })(Footer)



// WEBPACK FOOTER //
// ./src/components/footer.js